module.exports = __webpack_public_path__ + "img/waf-icon-active.09d944b.svg";